import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class ProcessButton extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const {dealer, agency, orders, reference, isToyotaUser} = this.props;
    const orderDealer = isToyotaUser ? orders[0].dealer : dealer;
    const orderAgency = isToyotaUser ? orders[0].agency : agency;

    this.props.createDealerStockOrder({
      orders,
      reference,
      'agency': orderAgency,
      'dealer': orderDealer,
    });
  }

  checkErrors() {
    const {orders} = this.props;
    return orders.some((order) => !!order.error);
  }

  render() {
    const {loading, generatedCode} = this.props;

    if (generatedCode) {
      return null;
    }

    return (
      <Button primary
        disabled={loading || this.checkErrors()}
        content='PEDIR'
        onClick={this.handleClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'isToyotaUser': state.session.isUserFromTDE,
    'dealer': state.session.dealerId,
    'agency': state.session.dealerAgency,
    'orders': state.dealerStockOrders.list,
    'loading': state.dealerStockOrders.loading,
    'reference': state.dealerStockOrders.filename,
    'generatedCode': state.dealerStockOrders.createdOrder,
  };
};

const {createDealerStockOrder} = Actions;

export default connect(mapStateToProps, {
  createDealerStockOrder,
})(ProcessButton);
